var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2347 22.6891C17.7437 22.6891 22.2097 18.2232 22.2097 12.7142C22.2097 7.20519 17.7437 2.73926 12.2347 2.73926C6.7257 2.73926 2.25977 7.20519 2.25977 12.7142C2.25977 18.2232 6.7257 22.6891 12.2347 22.6891Z",
    stroke: "white",
    strokeWidth: 1.88999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2597 23.7396L21.1597 21.6396",
    stroke: "white",
    strokeWidth: 1.88999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.306c88e1ef3db0677a8559246bff5888.svg";
export { ForwardRef as ReactComponent };